module.exports = __webpack_public_path__ + "static/mcnimbus_dark_194-632d84b17bdf45547da4bf74c574e44c.png";